import { FC, PropsWithChildren } from 'react';
import { Configure, InstantSearch } from 'react-instantsearch';
import { DEFAULT_SEARCH_HITS_PER_PAGE } from '#types/System.Parameters.types';
import { searchClient } from '../services/searchConfig';
import { algoliaConfig } from '../config';

interface SearchWrapperProps extends PropsWithChildren {
  /**
   * Number of results to return per page
   */
  hitsPerPage?: number;
  /**
   * Filters to apply to the search
   */
  filters?: string;
}

/**
 * Provides basic search context for Algolia InstantSearch.
 * Preserves search state when components unmount.
 * 
 * @example
 * <SearchWrapper hitsPerPage={20}>
 *   <SearchComponent />
 * </SearchWrapper>
 */
export const SearchWrapper: FC<SearchWrapperProps> = ({ 
  children,
  hitsPerPage = DEFAULT_SEARCH_HITS_PER_PAGE,
  filters = ''
}) => {
  if (!searchClient) return null;

  return (
    <InstantSearch 
      searchClient={searchClient} 
      indexName={algoliaConfig.allIndexName}
      future={{ preserveSharedStateOnUnmount: true }}
    >
      <Configure 
        hitsPerPage={hitsPerPage} 
        filters={filters}
      />
      {children}
    </InstantSearch>
  );
}; 